import isGuestRoute from '@/auth/isGuestRoute';
import router from '@/router';
import { errorHandler } from '../config';

errorHandler.onAuthError(() => {
  if (!isGuestRoute(router.currentRoute.value.path)) {
    router.push('/login?redirect=true');
  }
});
